module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._t("default"), _vm._v(" "), _c('div', {
    staticClass: "banner"
  }, [_c('div', {
    ref: "bg",
    staticClass: "bg",
    on: {
      "mouseover": function($event) {
        return _vm.bgOver(_vm.$refs.bg)
      },
      "mousemove": function($event) {
        return _vm.bgMove(_vm.$refs.bg, $event)
      },
      "mouseout": function($event) {
        return _vm.bgOut(_vm.$refs.bg)
      }
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, _vm._l((_vm.t_data), function(item, i) {
    return (i === _vm.mark) ? _c('div', {
      key: i,
      staticStyle: {
        "position": "absolute"
      },
      on: {
        "mouseover": _vm.stopTimer,
        "mouseout": _vm.startTimer
      }
    }, [(item.imgUrl) ? _c('img', {
      staticClass: "img1",
      attrs: {
        "src": item.imgUrl
      }
    }) : _vm._e()]) : _vm._e()
  }), 0)], 1), _vm._v(" "), _c('div', {
    staticClass: "page"
  }, [_c('ul', {
    staticClass: "dots"
  }, _vm._l((_vm.t_data), function(item, i) {
    return _c('li', {
      key: i,
      staticClass: "dot-active",
      class: {
        'dot': i != _vm.mark
      },
      on: {
        "click": function($event) {
          return _vm.change(i)
        }
      }
    })
  }), 0)]), _vm._v(" "), _c('div')])], 2)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-328d41fe", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-328d41fe"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/pc/custompage/components/plugins/banner/index.vue
// module id = 2599
// module chunks = 0